import { OnlyFilterActionDisplayStrategy } from '../../components/BPMTable/TableMapperCreator'
import TableCreatorCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import { getBayphonesTableDefinitions, bayphoneQueries } from './BayphoneTableDefinitions'

class BayphoneDashboardTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "BayphoneDashboardTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator = this.createTableCreator(this.constructor.getId(), tableName, bayphoneQueries, null, new OnlyFilterActionDisplayStrategy())

        const fieldDefinitions = getBayphonesTableDefinitions(false);
        tableCreator.addDescriptions(fieldDefinitions);

        return tableCreator
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(BayphoneDashboardTableCreator)

export default BayphoneDashboardTableCreator
